import { AttachedBar, FrontBar } from './bar'
import { DetachedBar } from './bar/DetachedBar'
import { LogsBack } from './log/LogsBack'
import { LogsFront } from './log/LogsFront'
import { useMontage } from '../../../context/montage.context'
import { Marquee } from './marquee/Marquee'
import { Windows } from './window/Windows'
import { Helper } from '../../../classes/helper'
import { GuideBar } from './bar/GuideBar'

export const TerraceCoverMesh = (): JSX.Element => {
  const { roof } = useMontage()

  return (
    <group
      position={[0, 0, Helper.coverStartPosition(roof.attachment)]}
      name={'k3d'}
    >
      <AttachedBar />
      <DetachedBar />
      <GuideBar />
      <Windows />
      <Marquee />
      <FrontBar />
      <LogsFront />
      <LogsBack />
    </group>
  )
}
